var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { PathLocationStrategy } from "@angular/common";
import { ErrorHandler } from "@angular/core";
import { HammerGestureConfig, } from "@angular/platform-browser";
import * as Sentry from "@sentry/browser";
import * as Hammer from "hammerjs";
import { environment } from "../environments/environment";
import Utils from "./utils/utils";
Sentry.init({
    dsn: window.PBSLM.SENTRY_JS_DSN,
    release: window.PBSLM.NG.VERSION,
    sampleRate: environment.sentry.sampleRate,
});
var SentryErrorHandler = /** @class */ (function () {
    function SentryErrorHandler() {
    }
    SentryErrorHandler.prototype.handleError = function (error) {
        if (!Utils.isIEBrowser() &&
            !Utils.isEdgeBrowser() &&
            environment.sentry.activate) {
            Sentry.captureException(error.originalError || error);
        }
        throw error;
    };
    return SentryErrorHandler;
}());
export { SentryErrorHandler };
var HammerConfig = /** @class */ (function (_super) {
    __extends(HammerConfig, _super);
    function HammerConfig() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.overrides = {
            swipe: { direction: Hammer.DIRECTION_HORIZONTAL },
            pinch: { enable: false },
            rotate: { enable: false },
            pan: { enable: false },
        };
        return _this;
    }
    return HammerConfig;
}(HammerGestureConfig));
export { HammerConfig };
// Allow trailing slash in routes
// For details, see https://stackoverflow.com/questions/48425111/angular-5-allow-trailing-slash-in-routes/48657772#
var _orig_prepareExternalUrl = PathLocationStrategy.prototype.prepareExternalUrl;
PathLocationStrategy.prototype.prepareExternalUrl = function (internal) {
    var url = _orig_prepareExternalUrl.call(this, internal);
    var /** @type {?} */ match = url.match(/#|\?|$/);
    var /** @type {?} */ pathEndIdx = (match && match.index) || url.length;
    var /** @type {?} */ droppedSlashIdx = pathEndIdx - (url[pathEndIdx - 1] === "/" ? 1 : 0);
    var first = url.slice(0, droppedSlashIdx);
    var last = url.slice(pathEndIdx);
    if (url === "") {
        return url;
    }
    // handle url params
    if (match) {
        return first + "/" + last;
    }
    if (url.endsWith("/")) {
        return url;
    }
    return url + "/";
};
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
